import {useState} from "react";
import {Box, Table, TableBody, TableCell, TableHead, TablePagination, TableRow} from "@mui/material";
import {CampaignRow} from "./CampaignRow";
import {CampaignCard} from "./CampaignCard";
import {paginate} from "../utils";

const headerCellSx = {
  fontWeight: 700, fontSize: 11, py: 1,
  color: "text.secondary", textTransform: "uppercase",
  letterSpacing: 0.5, bgcolor: "grey.50", whiteSpace: "nowrap",
};

const columns = ["Name", "From number", "Extension", "Dates", "Calling window", "Max attempts", "Phone numbers", "Status", "Created"];

const MessageRow = ({children}) => (
  <TableRow>
    <TableCell colSpan={columns.length + 1} align="center" sx={{py: 4, color: "text.secondary", fontSize: 13}}>
      {children}
    </TableCell>
  </TableRow>
);

// subProjectOf(campaign): optional label of the campaign's language (registry projects)
export const CampaignsTable = ({campaigns, loading, getExtension, subProjectOf, onOpen, onEdit, onDelete, viewMode = "list"}) => {
  const [page, setPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(10);
  const {currentPage, pageItems} = paginate(campaigns, page, rowsPerPage);

  return (
    <Box sx={{flex: 1, display: "flex", flexDirection: "column", overflow: "hidden"}}>
      <Box sx={{flex: 1, overflow: "auto", p: 0.5}}>
        {viewMode === "cards" ? (
          <Box sx={{display: "grid", gridTemplateColumns: {xs: "1fr", md: "repeat(2, 1fr)", xl: "repeat(3, 1fr)"}, gap: 2}}>
            {pageItems.map(campaign => (
              <CampaignCard key={campaign.id} campaign={campaign} extension={getExtension(campaign.extensionId)} language={subProjectOf?.(campaign)} onOpen={onOpen} onEdit={onEdit} onDelete={onDelete}/>
            ))}
            {campaigns.length === 0 && <Box sx={{gridColumn: "1 / -1", py: 6, textAlign: "center", color: "text.secondary"}}>{loading ? "Loading..." : "No campaigns yet"}</Box>}
          </Box>
        ) : (
        <Box className="border-shadow" sx={{borderRadius: 2, overflow: "auto"}}>
        <Table size="small" stickyHeader sx={{tableLayout: "auto"}}>
          <TableHead>
            <TableRow sx={{bgcolor: "grey.50"}}>
              {columns.map(column => <TableCell key={column} sx={headerCellSx}>{column}</TableCell>)}
              <TableCell padding={"checkbox"} sx={headerCellSx}/>
            </TableRow>
          </TableHead>
          <TableBody>
            {pageItems.map(campaign => (
              <CampaignRow key={campaign.id} campaign={campaign} extension={getExtension(campaign.extensionId)} language={subProjectOf?.(campaign)} onOpen={onOpen} onEdit={onEdit} onDelete={onDelete}/>
            ))}
            {campaigns.length === 0 &&
              <MessageRow>{loading ? "Loading..." : "No campaigns yet"}</MessageRow>
            }
          </TableBody>
        </Table>
        </Box>
        )}
      </Box>
      <TablePagination
        component="div"
        count={campaigns.length}
        page={currentPage}
        onPageChange={(e, newPage) => setPage(newPage)}
        rowsPerPage={rowsPerPage}
        onRowsPerPageChange={(e) => {
          setRowsPerPage(parseInt(e.target.value, 10));
          setPage(0);
        }}
        rowsPerPageOptions={[10, 25, 50]}
      />
    </Box>
  )
}
